import { useEffect, useState } from "react";
import { elapsedSeconds, formatDuration } from "../utils/date.js";

export default function TimerDisplay({ entry, entries, fallbackSeconds = 0 }) {
  const [, tick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => tick((value) => value + 1), 1000);

    return () => window.clearInterval(id);
  }, []);

  const visibleEntries = entries?.filter((item) => item.source?.name !== "AdminAdjusted");
  const totalSeconds = visibleEntries?.length
    ? visibleEntries.reduce((sum, item) => sum + elapsedSeconds(item), 0)
    : entry
      ? elapsedSeconds(entry)
      : fallbackSeconds;

  return <span className="timer-display">{formatDuration(totalSeconds)}</span>;
}
